export default __webpack_public_path__ + "static/683-84c048ad053b489eb687a84a6f34f00e.gif";